module.exports = __webpack_public_path__ + "static/scale-model-of-hollywood-wax-museum®-in-glendale-california-e22f312202c27e44298651d2c9cd62c9.png";